const brandsJson = JSON.parse(document.querySelector('#vendor-json').innerHTML);
const { brands, sectionId, settings: brandSettings } = brandsJson;

const brandsContainer = document.querySelector(`#brands_section-${sectionId}`);
const brandsLoadMoreBtn = brandsContainer.nextElementSibling?.querySelector('button');
const resizeController = new AbortController();

const renderNeededQty = (val) => {
  let brandsContent = '';

  if (typeof val === 'number') {
    brandsContent = brands.slice(0, val).join('');
    brandsContainer.innerHTML = brandsContent;
    brandsLoadMoreBtn.classList.toggle('hidden', brands.length <= val);
  } else {
    brandsContent = brands.slice(brandsContainer.childElementCount).join('');
    brandsContainer.insertAdjacentHTML('beforeend', brandsContent);
    resizeController.abort();
    brandsLoadMoreBtn.remove();
  }
};

const renderElements = () => {
  if (window.innerWidth < 1024) {
    renderNeededQty(Number(brandSettings.mobLimit));
  } else if (window.innerWidth < 1440) {
    renderNeededQty(Number(brandSettings.tabletLimit));
  } else {
    renderNeededQty(Number(brandSettings.deskLimit));
  }
};

renderElements();
brandsLoadMoreBtn?.addEventListener('click', renderNeededQty);
window.addEventListener('resize', renderElements, { signal: resizeController.signal });
